export default __webpack_public_path__ + "static/media/img-time-km@2x.7c99840e.png";